<div class="manage-project-wrapper">
  <div class="tabs">
    @if ((userService.data$ | async)?.isPaidAccount) {
      <div
        (click)="setSelectedTab(tabs.SERVICE_TEAM)"
        [ngClass]="{ active: selectedTab === tabs.SERVICE_TEAM }"
        class="tab"
      >
        <div class="label">External Team</div>
        <div class="icon-service-team"></div>
      </div>
    }

    @if (userService.isPremiumSP) {
      <div
        (click)="setSelectedTab(tabs.PRIME_CONTRACT)"
        [ngClass]="{ active: selectedTab === tabs.PRIME_CONTRACT }"
        class="tab"
      >
        <div class="label">Prime Contract</div>
        <div class="icon-prime-contract"></div>
      </div>
    }

    @if ((userService.data$ | async)?.isFreeSP) {
      <div (click)="setSelectedTab(tabs.COMMITMENTS)" class="tab-static">
        <div class="label">Manage Contract</div>
        <div class="icon-commitments"></div>
      </div>
    } @else {
      <div
        (click)="setSelectedTab(tabs.COMMITMENTS)"
        [ngClass]="{ active: selectedTab === tabs.COMMITMENTS }"
        class="tab"
      >
        <div class="label">Add Commitment</div>
        <div class="icon-commitments"></div>
      </div>
    }

    @if ((userService.data$ | async)?.isPaidAccount) {
      <div
        (click)="setSelectedTab(tabs.BUDGET_CASHFLOW)"
        [ngClass]="{ active: selectedTab === tabs.BUDGET_CASHFLOW }"
        class="tab"
        data-cy="budget-cashflow-tab"
      >
        <div class="label">Budget & Cashflow</div>
        <div class="icon-budget-cashflow"></div>
      </div>
    }
  </div>

  <ng-scrollbar class="std-scrollbar" appearance="compact" orientation="vertical">
    @if (selectedTab === tabs.SERVICE_TEAM) {
      <div class="tab-content">
        @if (isLoading) {
          <app-page-loading></app-page-loading>
        } @else if (isContractorsListEmpty()) {
          <div class="mt-4 text-center text-size_xl text-navy-600 font-semibold">
            No Service Providers invited to this project.
          </div>
        } @else {
          @for (contractorType of CONTRACTOR_TYPES; track contractorType.id) {
            @if (contractorsByType?.[contractorType.id]?.length > 0) {
              <div class="contractor-group">
                <div class="contractor-title contractor-item">{{ contractorType.text }}</div>
                @for (contractor of contractorsByType[contractorType.id]; track contractor.id) {
                  <div class="contractor-item flex justify-between items-center">
                    <div>
                      <div class="font-semibold text-size_xl">
                        {{ contractor.name }}
                      </div>
                      @if (contractor?.contract) {
                        <div class="text-size_m">Contract: {{ contractor.contract.value | money: 'positiveComa' }}</div>
                      } @else {
                        <div class="text-size_m">No Proposal Submitted</div>
                      }
                    </div>
                    <div class="flex gap-3">
                      <app-styled-options-list
                        (click)="$event.stopPropagation()"
                        [listItems]="itemOptions[contractor.id]"
                        [disabledActionList]="disabledOptions[contractor.id]"
                        (selectedOption)="registerItemOption($event, contractor)"
                      >
                        <span class="icon-options-inverted text-blue-700"></span>
                      </app-styled-options-list>
                    </div>
                  </div>
                }
              </div>
            }
          }
        }
      </div>
    }
    @if (selectedTab === tabs.PRIME_CONTRACT) {
      <div class="tab-content mt-5 flex flex-col gap-2.5">
        <div [appTooltip]="lineItems()?.length > 0 ? '' : NO_BUDGET">
          <div
            [ngClass]="{ 'visually-disabled': !lineItems()?.length }"
            (click)="openAddEditPrimeContract()"
            class="manage-button"
          >
            {{ (selectHasPrimeContract$ | async) ? 'Edit Prime Contract' : 'Add Prime Contract' }}
          </div>
        </div>
        <div
          [appTooltip]="(selectHasPrimeContract$ | async) === false ? NO_PRIME_CONTRACT : !CORs().length ? NO_COR : ''"
        >
          <div
            [ngClass]="{ 'visually-disabled': (selectHasPrimeContract$ | async) === false || !CORs().length }"
            (click)="openAddPrimeChangeOrder()"
            class="manage-button"
          >
            Add Prime Change Order
          </div>
        </div>
        <div [appTooltip]="(selectHasPrimeContract$ | async) ? '' : NO_PRIME_CONTRACT">
          <div
            [ngClass]="{ 'visually-disabled': (selectHasPrimeContract$ | async) === false }"
            (click)="openAddPrimeInvoice()"
            class="manage-button"
          >
            Add Prime Invoice
          </div>
        </div>
        <div [appTooltip]="lineItems()?.length > 0 ? '' : NO_BUDGET">
          <div
            [ngClass]="{ 'visually-disabled': !lineItems()?.length }"
            (click)="openAddAnticipatedIncome()"
            class="manage-button"
          >
            Anticipated Income
          </div>
        </div>
      </div>
    }

    @if (selectedTab === tabs.COMMITMENTS) {
      <div class="tab-content">
        <div class="mt-5 flex flex-col gap-2.5">
          <!--          @if (userService.isServiceProvider) {-->
          <!--            <div (click)="addProposal()" class="manage-button">Proposal</div>-->
          <!--          }-->
          @if (userService.isPremiumSP) {
            <div [appTooltip]="(selectHasPrimeContract$ | async) ? '' : NO_PRIME_CONTRACT">
              <div
                [ngClass]="{ 'visually-disabled': (selectHasPrimeContract$ | async) === false }"
                (click)="initiateChangeAction()"
                class="manage-button"
              >
                Initiate Change Action
              </div>
            </div>
          }

          <div [appTooltip]="lineItems()?.length > 0 ? '' : NO_BUDGET">
            <div
              [ngClass]="{ 'visually-disabled': !lineItems()?.length }"
              (click)="addCommitment(INTERACTION_BAR_STATES.SIDEBAR_ADD_CONTRACT)"
              class="manage-button"
            >
              Contract
            </div>
          </div>
          <div [appTooltip]="projectHasApprovedContract() ? '' : NO_SUBCONTRACT">
            <div
              [ngClass]="{ 'visually-disabled': projectHasApprovedContract() === false }"
              (click)="addCommitment(INTERACTION_BAR_STATES.SIDEBAR_CHANGE_ORDER)"
              class="manage-button"
            >
              <span>Change Order</span>
            </div>
          </div>
          <div [appTooltip]="projectHasApprovedContract() ? '' : NO_SUBCONTRACT">
            <div
              [ngClass]="{ 'visually-disabled': projectHasApprovedContract() === false }"
              (click)="addCommitment(INTERACTION_BAR_STATES.SIDEBAR_INVOICE)"
              class="manage-button"
            >
              <span>Invoice</span>
            </div>
          </div>
          @if (userService.isPaidAccount) {
            <div [appTooltip]="lineItems()?.length > 0 ? '' : NO_BUDGET">
              <div
                [ngClass]="{ 'visually-disabled': !lineItems()?.length }"
                (click)="addCommitment(INTERACTION_BAR_STATES.SIDEBAR_MISC_COST)"
                class="manage-button"
              >
                Direct Cost
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (selectedTab === tabs.BUDGET_CASHFLOW) {
      <div class="tab-content">
        <div class="mt-5 flex flex-col gap-2.5">
          <div (click)="openCashflowAllocation()" class="manage-button" data-cy="cashflow-allocation-button">
            Cashflow Allocation
          </div>
          <div [appTooltip]="lineItems()?.length > 0 ? '' : NO_BUDGET">
            <div
              [ngClass]="{ 'visually-disabled': !lineItems()?.length }"
              (click)="openBudgetAdjustment()"
              class="manage-button"
            >
              Budget Adjustment
            </div>
          </div>
          <div [appTooltip]="lineItems()?.length > 0 ? '' : NO_BUDGET">
            <div
              [ngClass]="{ 'visually-disabled': !lineItems()?.length }"
              (click)="openForecastModifications()"
              class="manage-button"
            >
              Add Anticipated Costs
            </div>
          </div>
          <div [appTooltip]="lineItems()?.length > 0 ? '' : NO_BUDGET">
            <div
              [ngClass]="{ 'visually-disabled': !lineItems()?.length }"
              (click)="setHistoryView()"
              class="manage-button"
            >
              Budget Historical
            </div>
          </div>
        </div>
      </div>
    }

    @if (selectedTab === tabs.PROPOSAL) {
      <div class="tab-content">
        <app-bid-proposal></app-bid-proposal>
      </div>
    }

    @if (selectedTab === tabs.CONTACTS) {
      <div class="tab-content">
        <div class="mt-6 text-navy-600 font-semibold text-size_xl text-center">No contacts to show at the moment.</div>
      </div>
    }
  </ng-scrollbar>
</div>
